<template>
  <favorite-card
    @click.native="favoriteClicked"
    :url="goalUrl"
    :saved-time="created"
    :class="{'favorite-super-page': goal.super_page}">
    <div class="goal-card-body" :class="{'goal-card-body--super-page': goal.super_page}">
      <remove-favorite-btn :favoriteid="goal.uuid" :type="resourceType" />
      <h4>{{ goal.title }}</h4>
      <span v-if="goal.subject" class="label label-success">{{ goal.subject }}</span>
      <span class="label label-default">{{ goal.subject_domains.join(", ") }}</span>
      <span class="label label-warning">{{ gradeLabelText }} {{ goal.grades.length > 1 && goal.grades[0] + "-" + goal.grades[goal.grades.length-1] || goal.grades.join(", ") }}</span>
      <div class="text-muted"><wiki-text :text="goal.goal_text" :plaintext="true" /></div>
      <div class="bottom-right">
        <anchor-page-label v-if="goal.super_page" />
      </div>
    </div>
  </favorite-card>
</template>

<script>
import WikiText from '@/components/WikiText'
import FavoriteCard from '@/components/favorites/FavoriteCard'
import AnchorPageLabel from '@/components/goals/AnchorPageLabel'
import RemoveFavoriteBtn from './RemoveFavoriteBtn'

export default {
  name: 'GoalDisplayCard',
  components: {
    RemoveFavoriteBtn,
    FavoriteCard,
    AnchorPageLabel,
    WikiText
  },
  data() {
    return {
      resourceType: 'goal'
    }
  },
  props: {
    goal: {
      type: Object,
      required: true
    },
    created: {
      type: String,
      required: true
    }
  },
  computed: {
    goalUrl() {
      return (
        (this.goal.super_page && { name: 'AnchorPage', params: { uuid: this.goal.uuid } }) || {
          name: 'GoalContentPage',
          params: { slug: this.goal.slug }
        }
      )
    },
    gradeLabelText() {
      return (this.goal.grades.length > 1 && 'Grades') || 'Grade'
    }
  },
  methods: {
    favoriteClicked: function() {
      this.$sendEvent('Clicked Favorite Goal', {
        goal_uuid: this.goal.uuid
      })
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.goal-card-body {
  overflow: hidden;
  height: 194px;
  padding: 20px;
  line-height: 20px;
  padding-bottom: 0px;
  margin-bottom: 12px;

  .remove-favorite-btn {
    visibility: hidden;
  }
  &:hover {
    .remove-favorite-btn {
      visibility: visible;
    }
    h4 {
      color: @link-hover-color;
    }
  }
  h4 {
    font-weight: bold;
    color: @link-color;
    margin-top: 0;
    margin-bottom: 2px;
  }
  .text-muted {
    margin-top: 12px;
    color: #aaa;
  }

  &.goal-card-body--super-page {
    h4 {
      color: #1c5498;
    }
    .text-muted {
      color: #777;
    }
  }
}
.bottom-right {
  position: absolute;
  bottom: 10px;
  right: 16px;
}
</style>
<style lang="less">
.favorite-super-page {
  .favorite-card {
    background-color: #d7dde6 !important;
  }
  .favorite-card__footer {
    background: #1c5498 !important;
    color: white !important;
    .fa-heart {
      color: #f14259 !important;
    }
  }
}
</style>
